import React, { useState } from 'react';
import PropTypes from 'prop-types';

import copyToClipboard from 'utils/clipboard';

import {
  Wrapper,
  PromptText,
  LeftContent,
  CopyButton,
  CopyButtonText,
  CopyIcon
} from './styled';

const PromptCopyCard = ({
  text,
  copyValue,
  leadingIcon,
  className
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const clipboardValue = copyValue || (typeof text === 'string' ? text : '');

    copyToClipboard(clipboardValue);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Wrapper className={ className }>
      <LeftContent>
        {leadingIcon}
        <PromptText>{text}</PromptText>
      </LeftContent>
      <CopyButton onClick={ handleCopy } type="button">
        <CopyButtonText>{copied ? 'Copied' : 'Copy'}</CopyButtonText>
        <CopyIcon />
      </CopyButton>
    </Wrapper>
  );
};

PromptCopyCard.propTypes = {
  text: PropTypes.node.isRequired,
  copyValue: PropTypes.string,
  leadingIcon: PropTypes.node,
  className: PropTypes.string
};

PromptCopyCard.defaultProps = {
  copyValue: '',
  leadingIcon: null,
  className: ''
};

export default PromptCopyCard;
